// hooks.ts
import { useDispatch } from 'react-redux';
import type { AppDispatch } from './store';

// eslint-disable-next-line import/prefer-default-export
export const useAppDispatch = () => useDispatch<AppDispatch>();
